<template>
  <router-link :to="{ name: item.route.name }">
    <v-tooltip :disabled="hasMainMenuOpen || isMobileDevice" right>
      <template v-slot:activator="{ on }">
        <span v-on="on">
          <span class="menu__item__icon" :class="`menu__item__icon--${item.icon}`" />
          <span class="menu__item__text">{{ $t(`${namespace}.${item.title}`) }}</span>
        </span>
      </template>
      <span>{{ $t(`${namespace}.${item.title}`) }}</span>
    </v-tooltip>
  </router-link>
</template>

<script>
import { mapState } from 'vuex'
import mediaQueries from 'mixins/mediaQueries'

export default {
  name: 'MenuItemLink',
  mixins: [mediaQueries],
  props: {
    item: {
      type: Object,
      require: true
    }
  },
  computed: {
    ...mapState({
      hasMainMenuOpen: ({ mainMenu }) => mainMenu.isOpen
    }),

    isMobileDevice () {
      return this.isMobile || this.isTablet
    }
  },
  data () {
    return {
      namespace: 'Components.MainMenu'
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
